const ENDPOINT = 'GETalbumtypes';
function getAlbumTypes(gateway, params) {
    return gateway.get(getAlbumTypes.endpoint, params);
}
getAlbumTypes.endpoint = ENDPOINT;

export { getAlbumTypes as default };
//# sourceMappingURL=getAlbumTypes.js.map
